import React, { useState, useEffect } from "react";
import "./Ebook.css";
import Dashboard from "../Dashboard/Dashboard";

import pdfimg from "../../images/pdf-icon.png";
import download from "../../images/download-icon.svg";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import loadimg from "../../images/pp-logo.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function Ebook({ globaltest, token,userdetail,onLoginChange }) {
  const [isLoading, setIsLoading] = useState(true);
  const [pdf, setpdf] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 25;

  // Compute current items for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = pdf.slice(indexOfFirstItem, indexOfLastItem);

  const subS = true;
  
  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [EbookImage,setEbookImage] = useState(null);

  const [EbookPrice,setEbookPrice] = useState(null);

  const [EbookTitle,setEbookTitle] = useState(null);

  const [Dimension,setDimension] = useState(null);

  const [loading, setLoading] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);

  const insufficient = queryParams.get("payment") === "failed";
    
  const [showInsufficientPopup, setShowInsufficientPopup] = useState(false);

  useEffect(() => {
      if (insufficient) {
          setShowInsufficientPopup(true);
      }
  }, [insufficient]);


  useEffect(() => {
    FetchPdfs();
  }, [token]); // refetch if token changes

  useEffect(() => {
    setCurrentPage(1);
  }, [pdf]);

  const HanddlePaymentModal = (dimension_id,ebook_sub_image) =>{

      setDimension(dimension_id);

      setEbookImage(ebook_sub_image);

      setShowModal(true);
  };

  useEffect(() => {

      const hideLoaderOnReturn = (event: PageTransitionEvent) => {
        if (event.persisted) {
          setLoading(false);
        }
      };

    window.addEventListener("pageshow", hideLoaderOnReturn);

    return () => {
      window.removeEventListener("pageshow", hideLoaderOnReturn);
    };
  }, []);



    const HandlePament = async (price) => {

      try {

        setLoading(true);

        const response = await fetch(`${END_URL}/ebook-payment`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            price: price,
            dimension_id: Dimension,
          }),
        });

        const data = await response.json();

        if (data.payment) {

          window.location.href = data.payment;
        } else {

          setLoading(false);

        }

      } catch (error) {

        console.error("Error sending result:", error);
        setLoading(false); 
      }
  };



  const FetchPdfs = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${END_URL}/get_pdfs`, {
        headers: { Authorization: `Bearer ${token}` },
      });


      setpdf(response.data.data);

      // setEbookImage(response?.data?.ebook_subcriptions);

      setEbookPrice(response?.data?.ebook_price);

      setEbookTitle(response?.data?.ebook_title);

    } catch (error) {

      console.error("Error fetching PDFs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ebook-main">
      <div className="container-fluid ebook-container">
        <div className="row">
          <div className="col-md-3">
            <Dashboard globaltest={globaltest} />
          </div>

          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <div className="ebook-data">
              <div className="row gy-1">
                
                <h3> {EbookTitle}</h3>
                
              {!isLoading && (

                currentItems && currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <div
                      className="col-12 col-sm-6 col-md-3 col-xl-custom"
                      key={item.id || index}
                    >
                      <div className="ebook-pdfDiv">
                    
                        <div>
                            <h6>{item.name}</h6>
                          <img
                              src={item?.pdf_image 
                                ? `${IMG_URL}/d0/${item.pdf_image}` 
                                : pdfimg
                              }
                              alt="PDF"
                          />

                          {item.pdf_file ? (
                            <a href={`${IMG_URL}/d0/ebook/${item.pdf_file}/${item.id}`}>
                              Download{" "}
                              <span>
                                <img src={download} alt="Download icon" />
                              </span>
                            </a>
                          ) : (
                      
                            <a className="ebook-lock"
                            
                               onClick={()=>HanddlePaymentModal(item?.dimension_id,item?.ebook_sub_image)}
                                  
                            >
                         
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 24 24"
                              >
                                <defs>
                                  <linearGradient
                                    id="grad"
                                    x1="0%"
                                    y1="0%"
                                    x2="100%"
                                    y2="100%"
                                  >
                                    <stop offset="0%" stop-color="purple" />
                                    <stop
                                      offset="100%"
                                      stop-color="goldenrod"
                                    />
                                  </linearGradient>
                                </defs>
                                <path
                                  d="M12 17a2 2 0 100-4 2 2 0 000 4z"
                                  fill="url(#grad)"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M6 8a6 6 0 1112 0v2h1a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V11a1 1 0 011-1h1V8zm2 2h8V8a4 4 0 00-8 0v2z"
                                  fill="url(#grad)"
                                />
                              </svg>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12">
                    <p>No E-Books available at the moment.</p>
                  </div>
                )

              )}

                {/* Pagination Controls */}
                {pdf.length > itemsPerPage && (
                  <div className="pagination-controls">
                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>

                    {/* Page number buttons */}
                    {Array.from(
                      { length: Math.ceil(pdf.length / itemsPerPage) },
                      (_, i) => i + 1
                    ).map((pageNum) => (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={pageNum === currentPage ? "active-page" : ""}
                        style={{
                          margin: "0 3px",
                          fontWeight:
                            pageNum === currentPage ? "bold" : "normal",
                        }}
                      >
                        {pageNum}
                      </button>
                    ))}

                    <button
                      onClick={() =>
                        setCurrentPage((prev) =>
                          Math.min(
                            prev + 1,
                            Math.ceil(pdf.length / itemsPerPage)
                          )
                        )
                      }
                      disabled={
                        currentPage === Math.ceil(pdf.length / itemsPerPage)
                      }
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* // )} */}
        </div>



        {ShowModal && (
                                  
            <div className="newdashpop-overlay subs-cognit-modal1 modal_subcript ebook-pop">

                <div className="newdashpop-inner">

                    <div className="newdashpop-container">

                        <button
                          className="newdashpop-close"
                          onClick={() => setShowModal(false)}
                          >
                          &times;
                      </button>

                      <div className="conent-pop">

                            <a
                                onClick={() => !loading && HandlePament(EbookPrice)}

                                style={{ pointerEvents: loading ? "none" : "auto" }}
                              >

                                {loading ? (

                                  <img src={loadimg} class="ebook-pop-loader" alt="Loading..." />


                                ) : (

                                    EbookImage ? (

                                        <img src={`${IMG_URL}/d0/${EbookImage}`} />

                                    ):(

                                        <span>Pay Now</span>
                                    )
                                )}

                          </a>

                       
                      </div>

                    </div>

                </div>

            </div>
          )}




           {showInsufficientPopup && (
                                            
                <div className="newdashpop-overlay insufficientPayment">
                
                    <div className="newdashpop-inner">
                        <div className="newdashpop-container sub-no">

                            <button className="newdashpop-close"
                                onClick={() => {
                                    setShowInsufficientPopup(false);
                                    window.history.replaceState({}, "", window.location.pathname);
                                }}
                            >
                                &times;
                            </button>

                            <div className="conent-pop subs-left">

                                {/* <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html:Subcription?.sub_data?.payment_failed_msg }} /> */}
                              
                                <button
                                        onClick={() => {
                                            setShowInsufficientPopup(false);
                                            window.history.replaceState({}, "", window.location.pathname);
                                        }}
                                    >
                                    Close
                                    <span>
                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                    </span>
                                </button>

                            </div>

                        </div>
                    </div>
                </div>
            )}


      </div>
    </div>
  );
}

export default Ebook;
